import { useConfig } from "../hooks/useConfig";
import { charitySentence } from "../lib/charity";

/**
 * The disclaimer every page carries. Rendered by Layout so no route can ship
 * without it. The second line is the charity line, read from config.
 */
export function Disclaimer() {
  const { config } = useConfig();
  return (
    <div className="disclaimer">
      <div className="shell stack stack-2">
        <p>
          $TISM is a memecoin with no intrinsic value, no rights, no revenue share and no roadmap.
          Its price can go to zero. Nothing here is investment advice or an offer to anyone in a
          place where that would be unlawful.
        </p>
        <p>{charitySentence(config)}</p>
      </div>
    </div>
  );
}
